import { NoDataException } from 'src/com/sixdee/crbtportal/utils/exceptions/nodataexistsexception';
import { FlashMessageDto, FlashMessageDtoImpl } from '../get/flashmessagedto';

export class GetPredefinedFlashMessageBuilder
{
    constructor(private flashMessageList: any)
    {
        if(flashMessageList.flashDetails === undefined)
        {
            throw new NoDataException("FlashMessage data doesnt exists");
        }
    }

    buildAll(): FlashMessageDto[]
    {
        return this.parseFlashMessageDetailsResponse();
    }
    
    private parseFlashMessageDetailsResponse(): FlashMessageDto[]
    {
        let listOfFlashMessage: FlashMessageDto[] = [];
        
        let flashmessagedto = null;
        this.flashMessageList.flashDetails.forEach((messagesJson: any) =>
        {
            flashmessagedto = new FlashMessageDtoImpl();
            flashmessagedto.setId(messagesJson.id);
            flashmessagedto.setStatusMessage(messagesJson.message);
       
            listOfFlashMessage.push(flashmessagedto);
        });
        return listOfFlashMessage;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/flashmessage/getpredefinedflashes/getpredefinedflashmessagebuilder.ts